/* WakeUp V2 native horizontal scroller. No Flickity / OverlayScrollbars dependency. */
(() => {
  'use strict';
  function updateScrollbarWidth() {
    const width = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
  }

  if (!customElements.get('theme-scroll')) {
    class WubNativeScroll extends HTMLElement {
      connectedCallback() {
        if (this.dataset.wubNativeScrollReady === 'true') return;
        this.dataset.wubNativeScrollReady = 'true';
        this.viewport = this.querySelector('.wub-scroll__inner') || this.firstElementChild;
        this.prev = this.querySelector('.wub-scroll-prev');
        this.next = this.querySelector('.wub-scroll-next');
        if (!this.viewport) return;
        this.style.display = 'block';
        this.viewport.style.overflowX = 'auto';
        this.viewport.style.overscrollBehaviorX = 'contain';
        this.viewport.style.webkitOverflowScrolling = 'touch';
        this.viewport.style.scrollbarWidth = 'none';
        this.onNavClick = this.onNavClick.bind(this);
        this.update = this.update.bind(this);
        if (this.prev || this.next) this.addEventListener('click', this.onNavClick);
        this.viewport.addEventListener('scroll', this.update, { passive: true });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.viewport);
        }
        requestAnimationFrame(this.update);
      }
      disconnectedCallback() { this.resizeObserver?.disconnect(); }
      getStep() {
        const slides = this.viewport.querySelectorAll('.wub-scroll-item, .collection-card, .multicolumn--column, .gallery-item');
        if (slides.length > 1) {
          const step = Math.abs(slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left);
          if (step > 0) return step;
        }
        return Math.max(240, this.viewport.clientWidth * .82);
      }
      onNavClick(event) {
        const button = event.target.closest('.wub-scroll-button, .wub-scroll-nav');
        if (!button || !this.contains(button)) return;
        const direction = button.name === 'prev' ? -1 : 1;
        this.viewport.scrollBy({ left: direction * this.getStep(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      update() {
        if (!this.viewport) return;
        const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const atStart = this.viewport.scrollLeft <= 1;
        const atEnd = this.viewport.scrollLeft >= max - 1;
        if (this.prev) { this.prev.disabled = atStart; this.prev.classList.toggle('is-disabled', atStart); }
        if (this.next) { this.next.disabled = atEnd; this.next.classList.toggle('is-disabled', atEnd); }
      }
    }
    customElements.define('theme-scroll', WubNativeScroll);
  }
  updateScrollbarWidth();
  window.addEventListener('resize', updateScrollbarWidth, { passive: true });
})();
